export function dangerouslySetHtml(content) {
  return { __html: content };
}
